import React, { useEffect, useState } from 'react'
import { Button, Checkbox, FlexboxGrid, Input, InputGroup, Loader, Message, Modal, Pagination, Stack, Table, toaster } from 'rsuite';
import globalIP from '@/GlobelIP';

interface PaginationData {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
}
type YourDataType = {
    id: number;
    attributes: {
        CoverImage: any;
        ProductName: string;
        ProductId: string;
        ProductTypeName: string;
        SizeUnit: string;
        Length: number;
        Width: number;
        Height: number;
        Color: string;
        Finish: string;
        cbm: number;
        CategoryCode: string;
        CategoryName: string;
        ProductTypeCode: string;
        Description: string;
        FinishName: string;
        ColorName: string;
        NetWeight: number;
        GrossWeight: number;
        SellingPrice: number;
        SellingPriceCurrency: string;
        Product_Remark: string;
        shape: string;
        Total_CBM: number;
        SizeRange: string;

        // Add other attribute properties here
    };
};

interface MetaData {
    pagination: PaginationData;
}
const AddRemoveProductModal = ({
    showModal, setShowModal, fetchData, modalSelectedItems, setModalSelectedItems, label, }) => {
    const [page, setPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [meta123, setMeta123] = useState<MetaData>();
    const [data123, setData123] = useState<YourDataType[]>([]);
    useEffect(() => {
        fetchData123();
    }, [page]);
    const handleSearch = value => {
        setSearchQuery(value);
    };

    const handleModalCheckboxChange = (value, checked) => {

        if (checked) {
            setModalSelectedItems(prevSelected => [...prevSelected, value]);
        } else {

            setModalSelectedItems(prevSelected => prevSelected.filter(item => item !== value));

        }
    };
    const handleConfirmModal = () => {
        if (modalSelectedItems.length === 0) {
            toaster.push(
                <Message showIcon type="warning">
                    Please select at least one product.
                </Message>,
                { placement: 'topEnd' }
            );
        } else {

            const newSelectedItems = modalSelectedItems.map(Number); // Convert to numbers
            const newSelectedItemsString = newSelectedItems.join(',');
            // Update URL params
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set('selectedItems', newSelectedItemsString);
            const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
            window.history.pushState({}, '', newUrl);
            // Fetch data based on the new selection
            fetchData();
            setShowModal(false);
        }
    };

    const fetchData123 = async () => {
        let searchQryFilter = '';
        if (searchQuery.length > 0) {
            let searchQryy = searchQuery.trim();
            const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}`;
            searchQryFilter = `&${searchQry}`;
        }

        const response = await fetch(
            `${globalIP}/api/products?populate=*&sort[0]=id:desc&filters[Authorized][$eq]=Authorised&pagination[page]=${page}${searchQryFilter}`
        );
        const json = await response.json();

        setData123(json.data);
        setMeta123(json.meta);
    };

    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

    // Debounce effect for searchQuery
    useEffect(() => {
        setPage(1);
        const timer = setTimeout(() => {
            setDebouncedSearchQuery(searchQuery);
        }, 500); // Adjust the debounce delay as needed

        return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
    }, [searchQuery]);

    // Effect that triggers on debouncedSearchQuery
    useEffect(() => {
        // console.log('searchQuery', debouncedSearchQuery);
        setPage(1);
        fetchData123(); // Your data fetching function
    }, [debouncedSearchQuery]);

    const handleChangeLimit = () => {
        setPage(1);
    };
    return (
        <Modal size="lg" open={showModal} onClose={() => setShowModal(false)} backdrop="static">
            <Modal.Header>
                <Modal.Title>
                    <Stack style={{ marginRight: '10px' }} justifyContent="space-between">
                        <b>Select Products to Add/Remove</b>{' '}
                        <Input
                            placeholder="Search"
                            type="text"
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </Stack>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table
                    data={data123}
                    autoHeight
                    rowKey="id"
                    cellBordered
                    rowHeight={60}
                >
                    <Table.Column width={60} align="center" fixed>
                        <Table.HeaderCell>
                            <b style={{ fontSize: '14px' }}>Sr.No.</b>
                        </Table.HeaderCell>
                        <Table.Cell>{(_, rowIndex) => rowIndex + 1}</Table.Cell>
                    </Table.Column>

                    <Table.Column width={80} align="center">
                        <Table.HeaderCell>
                            <b>Select</b>
                        </Table.HeaderCell>
                        <Table.Cell>
                            {rowData => (
                                <Checkbox
                                    value={rowData.id}
                                    checked={modalSelectedItems.includes(rowData.id)}
                                    onChange={(value, checked) => handleModalCheckboxChange(value, checked)}
                                />
                            )}
                        </Table.Cell>
                    </Table.Column>
                    <Table.Column flexGrow={1} align="center">
                        <Table.HeaderCell>
                            <b>{label[0]?.attributes.ProductName}</b>
                        </Table.HeaderCell>
                        <Table.Cell dataKey="attributes.ProductName" />
                    </Table.Column>
                    <Table.Column flexGrow={1} align="center">
                        <Table.HeaderCell>
                            <b>{label[0]?.attributes.AliasCode}</b>
                        </Table.HeaderCell>
                        <Table.Cell dataKey="attributes.ProductId" />
                    </Table.Column>
                    <Table.Column flexGrow={1} align="center">
                        <Table.HeaderCell>
                            <b>Image</b>
                        </Table.HeaderCell>
                        <Table.Cell>
                            {rowData => (
                                <img
                                    src={`${globalIP}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                                    alt="Product Image"
                                    style={{ width: 50, height: 50, objectFit: 'contain' }}
                                />
                            )}
                        </Table.Cell>
                    </Table.Column>
                </Table>
                <div style={{ padding: 20 }}>
                    <Pagination
                        prev
                        next
                        first
                        last
                        ellipsis
                        boundaryLinks
                        limit={25}
                        maxButtons={5}
                        size="xs"
                        layout={['total', '-', 'pager', 'skip']}
                        // total={filterdata123.length}
                        total={meta123?.pagination?.total || 0}
                        activePage={page}
                        onChangePage={setPage}
                        onChangeLimit={handleChangeLimit}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    style={{ marginTop: '20px', opacity: modalSelectedItems.length == 0 ? '0.8' : '1' }}
                    onClick={handleConfirmModal}
                    appearance="primary"
                    color="cyan"
                >
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddRemoveProductModal